export default "__VITE_ASSET__DqEsEdmw__"